import React from "react";

const Icon = props => (
  <svg width={70} height={70} fill="none" viewBox="0 0 257 257" {...props}>
    <g clipPath="url(#clip0)">
      <path
        fill="#3E4C68"
        d="M38.2 0h180c19.6 0 35.6 16 35.6 35.6v185.2c0 19.6-16 35.6-35.6 35.6h-180c-19.6 0-35.6-16-35.6-35.6V35.2C2.6 16 18.6 0 38.2 0z"
      />
      <path
        fill="#00B594"
        d="M118.6 167.6l-52.4-52.8-63.6 63.6v42.4c0 19.6 16 35.6 35.6 35.6h180c19.6 0 35.6-16 35.6-35.6v-68.4l-59.6-60-75.6 75.2z"
      />
      <path
        fill="#FFCC03"
        d="M117.4 107.2c12.371 0 22.4-10.029 22.4-22.4 0-12.371-10.029-22.4-22.4-22.4-12.371 0-22.4 10.029-22.4 22.4 0 12.371 10.029 22.4 22.4 22.4z"
      />
      <path
        fill="#fff"
        d="M81.75 80.756c-.728 6.21-.146 13 1.456 20.077.291 1.3 1.456 2.167 2.766 2.167 1.747 0 3.057-1.733 2.766-3.467-2.33-9.822-2.184-18.922.583-26.289l-7.571 7.512zm19.8-23.834l20.819-20.655c.582.144 1.019.289 1.602.289 3.203 0 5.823-2.6 5.823-5.778 0-3.178-2.62-5.778-5.823-5.778-3.203 0-5.824 2.6-5.824 5.778 0 .722.146 1.444.437 2.166L98.056 53.311 95.726 51c-.582-.578-1.31-.867-2.038-.867-.728 0-1.456.29-2.038.867l-8.299 8.233c-1.164 1.156-1.164 2.89 0 4.045l2.33 2.31L65.007 86.1a5.882 5.882 0 00-2.184-.433c-3.202 0-5.823 2.6-5.823 5.777 0 3.178 2.62 5.778 5.824 5.778 3.203 0 5.823-2.6 5.823-5.778 0-.577-.146-1.01-.291-1.588L89.175 69.2l2.33 2.311c.582.578 1.31.867 2.038.867.728 0 1.456-.29 2.038-.867l8.298-8.233c1.165-1.156 1.165-2.89 0-4.045l-2.329-2.31zM93.543 65.3l-4.077-4.044 4.077-4.045 4.076 4.045-4.076 4.044zm19.363-15.456l-7.571 7.512c3.931-1.445 8.299-2.167 13.103-2.167 10.046 0 21.547 3.178 33.486 8.955 1.892.867 4.076-.433 4.076-2.455v-.145c0-1.01-.582-2.022-1.601-2.455-14.705-7.367-29.264-10.545-41.493-9.245z"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H256.4V256.4H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
